import React from "react";
let range = require("lodash.range");

export class IconlistLoading extends React.Component {
    render() {
        let gridCells = [],
            i,
            iconsPerRow = this.props.iconsPerRow || 6,
            rowClass = "Grid-cell-row container _" + iconsPerRow,
            rowNumber = 6,
            rows = [];

        for (i in range(iconsPerRow)) {
            gridCells.push(
                <div
                    key={"loading.row.gridCell." + i}
                    className="Grid-cell no-img"
                />
            );
        }
        for (i in range(rowNumber)) {
            rows.push(
                <section key={"loading.row." + i} className="row-container">
                    <div className={rowClass}>{gridCells}</div>
                </section>
            );

            return <div className="Grid">{rows}</div>;
        }
    }
}
